// src/store/index.js
import { createStore } from 'vuex';
import users from './modules/users';
import modals from './modules/modals';
import history from './modules/history';
import serviceOrders from './modules/serviceOrders';

export default createStore({
  state: {
    isTheme: "dark",
    shops: {
      pagination: {
        page: 1,
        limit: 10,
        first: 0
      },
      search: {
        query: '',
      },
      selectedShop: null
    },

    selectedBay: null
  },
  getters: {
    shopsPagination: state => state.shops.pagination,
    shopsSearch: state => state.shops.search,

    theme: state => state.isTheme,
    selectedBay: state => state.selectedBay
  },
  mutations: {
    setTheme(state, theme) {
      state.isTheme = theme;
    },
    setShopsPagination(state, payload) {
      state.shops.pagination = {
        page: payload.page,
        limit: payload.limit,
        first: payload.first
      };
    },
    setShopsSearch(state, payload) {
      state.shops.search = {
        query: payload.query,
      };
    },
    setSelectedShop(state, shop) {
      state.shops.selectedShop = shop;
    },
    setSelectedBay(state, bay) {
      state.selectedBay = bay;
    },

  },
  actions: {
    initializeTheme({ commit }) {
      const storedTheme = localStorage.getItem('isTheme');
      if (storedTheme) {
        commit('setTheme', storedTheme);
      } else {
        localStorage.setItem('isTheme', 'dark');
        commit('setTheme', 'dark');
      }
    },
    changeTheme({ commit }, theme) {
      localStorage.setItem('isTheme', theme);
      commit('setTheme', theme);
    },
    updateShopsPagination({ commit }, pagination) {
      commit('setShopsPagination', pagination);
    },
    updateShopsSearch({ commit }, search) {
      commit('setShopsSearch', search);
    },

  },
  modules: {
    users,
    modals,
    history,
    serviceOrders
  }
});
